import { Component, HostListener, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResizeDetectionService } from './services/resize-detection.service';
import { register as registerSwiperElements } from 'swiper/element/bundle';
registerSwiperElements(); // Registers <swiper-container> and <swiper-slide>

@Component({
  selector: 'app-nutrigenic',
  templateUrl: './nutrigenic.component.html',
  styleUrls: ['./nutrigenic.component.scss']
})
export class NutrigenicComponent implements AfterViewInit {
  underConstruction: boolean = false;
  isTablet: boolean = false;
  isMobile: boolean = false;
  isDesktop: boolean = false;
  openLuckyWinnerSubscribePopup: boolean = false;

  constructor(private router: Router, private sizedetection: ResizeDetectionService) { }

  ngOnInit() {
    this.openLuckyWinnerSubscribePopup = false;
    this.sizedetection.refreshSize();
    this.sizedetection.sizeCondition$.subscribe(data => {
      this.isDesktop = data.isDesktop;
      this.isTablet = data.isTablet;
      this.isMobile = data.isMobile;
      
    });
  }
  get containerClass(): any {
    return {
      'layout-theme-light': 'light',
      'layout-overlay': 'overlay',
      'layout-static': 'static',
      'layout-static-inactive': 'static',
      'layout-overlay-active': false,
      'layout-mobile-active': false,
      'p-input-filled': 'filled',
      'p-ripple-disabled': !true
    };
  }

  @HostListener('window:resize', ['$event'])
  onResize(): void {
    let isMobile = window.innerWidth <= 500;
    let isTablet = window.innerWidth > 500 && window.innerWidth <= 979;
    let isDesktop = window.innerWidth >= 980;
    this.sizedetection.updateConditions(isMobile, isTablet, isDesktop);
  }

  ngAfterViewInit() {
            requestAnimationFrame(() => {
                // This runs after the browser has painted
                setTimeout(() => {
                    this.openLuckyWinnerSubscribePopup = true;
                }, 2);
        });

    }
}
